<template>
    <v-container fluid grid-list-lg class="pa-3">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-toolbar dense prominent>
                        <v-toolbar-title>Activity Details</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn fab small v-on="on" @click="drawer = !drawer" v-if="selected._id" v-show="false">
                                    <v-icon dark>question_answer</v-icon>
                                </v-btn>
                            </template>
                            <span>Messages</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn fab small color="primary" v-on="on" :href="'/Submit-Evidence-Step2-Crud?uuid=33297989-4029-4a57-9aba-65724eb4cee0&fpes_report_entries_id=' + selected.fpes_report_entries_id" v-if="selected._id">
                                    <v-icon dark>add_circle_outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Add New Activity</span>
                        </v-tooltip>
                    </v-toolbar>

                    <v-card-text class="px-0 pt-2 pb-0">
                        <v-tabs v-model="tab_idx">
                            <v-tabs-slider color="primary"></v-tabs-slider>
                            <v-tab>Basic</v-tab>
                            <v-tab v-show="selected._id">Attachments</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab_idx">
                            <div style="border-top: solid 1px #ebebeb;">
                                <v-tab-item>
                                    <v-form ref="MainForm" lazy-validation>
                                        <v-container class="pa-3" fluid>
                                            <v-layout row wrap v-show="selected._id">
                                                <v-flex class="text-xs-right" xs12>
                                                    <v-menu open-on-hover bottom offset-y left style="display: inline-block;">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn outline color="red lighten-1" round @click="thumb_down_onlick" v-on="on">
                                                                {{ thunmb_down }} Unsupported
                                                                <v-icon right>thumb_down_off_alt</v-icon>
                                                            </v-btn>
                                                        </template>

                                                        <v-list two-line dense v-if="all_thumb_down_users.length > 0">
                                                            <template v-for="(item, index) in all_thumb_down_users">
                                                                <v-divider inset :key="'b' + index"></v-divider>
                                                                <v-list-tile avatar :key="'a' + index">
                                                                    <v-list-tile-avatar>
                                                                        <v-icon class="grey lighten-1 white--text">person</v-icon>
                                                                    </v-list-tile-avatar>

                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title>{{ item.username }}</v-list-tile-title>
                                                                        <v-list-tile-sub-title>{{ epoch2date(item.epoch) }}</v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </template>
                                                        </v-list>
                                                    </v-menu>

                                                    <v-menu open-on-hover bottom offset-y left style="display: inline-block;">
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn outline color="green" round @click="thumb_up_onlick" v-on="on">
                                                                {{ thunmb_up }} Supported
                                                                <v-icon right>thumb_up_off_alt</v-icon>
                                                            </v-btn>
                                                        </template>

                                                        <v-list two-line dense v-if="all_thumb_up_users.length > 0">
                                                            <template v-for="(item, index) in all_thumb_up_users">
                                                                <v-divider inset :key="'g' + index"></v-divider>
                                                                <v-list-tile avatar :key="'h' + index">
                                                                    <v-list-tile-avatar>
                                                                        <v-icon class="grey lighten-1 white--text">person</v-icon>
                                                                    </v-list-tile-avatar>

                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title>{{ item.username }}</v-list-tile-title>
                                                                        <v-list-tile-sub-title>{{ epoch2date(item.epoch) }}</v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </template>
                                                        </v-list>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex>
                                                    <v-textarea label="Full Description" class="dull" :rules="[rules.required, rules.max_length_exceeded]" v-model="selected.full_description" counter="1000"></v-textarea>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap >
                                                <v-flex xs12 sm6>
                                                    <v-select v-model="selected.group_category_id" class="dull" :items="all_group_category" label="Group Category" item-text="label" item-value="_id"></v-select>
                                                </v-flex>

                                                <v-flex xs12 sm6>
                                                    <v-select v-model="selected.status_id" class="dull" :items="all_status" label="Status" item-text="label" item-value="_id"></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs12 sm6>
                                                    <v-text-field v-model="selected.created_by" label="Created by" hint="Created date/time:" :messages="epoch2date(selected.created)" readonly></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 sm6>
                                                    <v-text-field readonly :messages="epoch2date(selected.modified)" v-model="selected.modified_by" hint="Last modified date/time:" label="Last modified by">
                                                    </v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex class="text-xs-right">
                                                    <v-btn color="dull" :block="this.$vuetify.breakpoint.xs" :href="'/Submit-Evidence-Crud/?uuid=dc0931b5-f388-421d-85ac-01024faa9160&_id=' + selected.fpes_report_entries_id">
                                                        <v-icon left>cancel</v-icon>Cancel
                                                    </v-btn>

                                                    <v-btn color="primary" @click="evidence_save_onclick" :block="this.$vuetify.breakpoint.xs">
                                                        <v-icon left>save</v-icon>
                                                        Save
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>

                                </v-tab-item>
                                <v-tab-item>
                                    <v-container class="pa-3" fluid style="min-height: 350px;">
                                        <v-layout row wrap>
                                            <v-flex class="pa-0">
                                                <input type="file" ref="fileUpload" accept=".pdf, .txt, .png, .jpg, .gif, .xls, .doc, .ppt, .ods, .docx, .xlsx, .pptx" style="display:none;" multiple />
                                                <v-btn color="primary" @click="upload_onclick" :block="this.$vuetify.breakpoint.xs">
                                                    <v-icon left>upload</v-icon>
                                                    Upload Supporting Document
                                                </v-btn> You can upload up to 6 files to the application, but each file must be 3 MB or smaller in size.
                                            </v-flex>
                                        </v-layout>

                                        <v-layout row wrap>
                                            <v-flex>
                                                <div style="border:1px solid rgb(211, 211, 211);min-height:300px;background-color: #faf9f9;">
                                                    <v-container fluid class="pa-2">
                                                        <v-layout row wrap>
                                                            <v-flex class="pa-3" xs12 sm12 md6 lg4 xl3 v-for="(evidence, idx) in selected.uploaded_evidence" :key="idx">
                                                                <v-card class="pt-3 px-3 pb-1">
                                                                    <v-layout>
                                                                        <v-flex xs3 class="text-xs-center">
                                                                            <v-icon v-if="evidence.type == 'application/pdf'" size="60">picture_as_pdf</v-icon>
                                                                            <v-icon v-else size="60">description</v-icon>
                                                                        </v-flex>
                                                                        <v-flex xs9>
                                                                            <div>
                                                                                <div style="text-overflow: ellipsis; overflow: hidden;">
                                                                                    <a @click="download_file(evidence)">
                                                                                        <b>{{ evidence.file_name }}</b>
                                                                                    </a>
                                                                                </div>
                                                                                <div>
                                                                                    <v-icon>account_circle</v-icon>
                                                                                    <span class="font-weight-medium" style="position: relative;top:-3px;">
                                                                                        {{ evidence.created_by }}
                                                                                        <span class="ml-3 caption">({{ calculate_size(evidence.size) }} KB)</span>
                                                                                    </span>
                                                                                </div>
                                                                                <div>
                                                                                    <span class="caption font-weight-light">{{ epoch2date(evidence.created) }} </span>
                                                                                </div>
                                                                            </div>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-card-actions class="pa-1">
                                                                        <v-spacer></v-spacer>
                                                                        <v-icon color="red lighten-3" @click="delete_file_omclick(evidence)">delete</v-icon>
                                                                    </v-card-actions>
                                                                </v-card>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>

                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-tab-item>
                            </div>
                        </v-tabs-items>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-navigation-drawer width="350px" v-model="drawer" clipped right absolute app temporary>
            <v-container fluid fill-height class="pt-0 pl-0 pr-0" style="padding-bottom: 50px;">
                <v-layout class="pa-0 ma-0">
                    <v-flex class="pa-0 ma-0">
                        <v-layout class="pa-0 ma-0">
                            <v-flex class="pa-0 ma-0">
                                <v-toolbar dense prominent>
                                    <v-toolbar-title>Messages</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </v-flex>
                        </v-layout>
                        <v-layout fill-height class="pa-0 ma-0">
                            <v-flex class="pa-1 ma-0" style="overflow: hidden;">
                                <component :FromUsername="current_username" :EventName="selected._id" :is="component" />
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-container>


        </v-navigation-drawer>
    </v-container>
</template>

<script>
import general from "../../functions/general";
import auth from "../../functions/auth";
import communication from "../../functions/communication.api";
//import WChat from "../../components/WChat/WChat";

let MAX_FILE_SIZE = 1024 * 1024 * 3; // 3 Mbytes

export default {
    name: "Submit-Evidence-Step2-Crud",
    components: {
        //WChat
    },
    watch: {
        "selected._id": function (val) {
            if (val.length > 2) {
                //this.component = "WChat";
            } else {
                //this.component = false;
            }
        }
    },
    data() {
        return {
            component: false,
            current_username: auth.getUsername(),
            drawer: null,
            items: [],
            tab_idx: 0,
            all_status: [],
            all_group_category: [],
            rules: {
                required: (value) => !!value || "This field required.",
                greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
                max_length_exceeded: (value) => value.length < 1000 || 'Max length exceeded.',
            },
            selected: {
                _id: "",
                fpes_report_entries_id: "",
                full_description: "",
                status_id: "",
                group_category_id: "",
                created: 0,
                created_by: "",
                modified: 0,
                modified_by: "",
                uploaded_evidence: [],
                thumbs: [],
            }
        };
    },
    computed: {
        download_link_base_url() {
            return communication.BASE_URL + "fpes/get_file_/";
        },
        thunmb_up() {
            var value = 0;
            var all_array = this.selected.thumbs;

            for (let i = 0, m = all_array.length; i < m; i++) {
                let el = all_array[i];
                if (el.value == 1) {
                    value++;
                }
            }
            return value;
        },
        thunmb_down() {
            var value = 0;
            var all_array = this.selected.thumbs;

            for (let i = 0, m = all_array.length; i < m; i++) {
                let el = all_array[i];
                if (el.value == -1) {
                    value++;
                }
            }
            return value;
        },
        all_thumb_up_users() {
            var ret = [];

            var all_array = this.selected.thumbs;

            for (let i = 0, m = all_array.length; i < m; i++) {
                let el = all_array[i];
                if (el.value == 1) {
                    ret.push(el);
                }
            }

            return ret;
        },
        all_thumb_down_users() {
            var ret = [];

            var all_array = this.selected.thumbs;

            for (let i = 0, m = all_array.length; i < m; i++) {
                let el = all_array[i];
                if (el.value == -1) {
                    ret.push(el);
                }
            }

            return ret;
        },
    },
    methods: {
        epoch2date: general.App.epoch2LocaleDatetime,
        async download_file(opt) {
            var download_url = communication.BASE_URL + "fpes/download_evidence_file/?actual_file_name=" + opt.actual_file_name;

            fetch(download_url, {
                method: 'GET',
            })
                .then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = opt.file_name;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                });

        },
        async delete_file_omclick(f) {
            general.App.loader.show(this);
            var data = {
                _id: this.selected._id,
                file: f
            };

            var url = "fpes/upload_evidence/";
            var res = await general.wBackEndComm.DeleteData(url, data);
            res = res.data;
            if (res.Status == 1) {
                this.selected.uploaded_evidence = res.Body.uploaded_evidence;
                this.selected.modified_by = res.Body.modified_by;
                this.selected.modified = res.Body.modified;

                general.wMsgBox.Success(res.Description);
            } else {
                general.wMsgBox.Error(res.Description);
            }
            general.App.loader.hide(this);
        },
        upload_onclick() {
            this.$refs.fileUpload.click();
        },
        calculate_size(val) {
            var temp = val / 1024;

            return temp.toFixed(2);
        },
        async checkIt() {
            let Files_Error = [];

            if (this.$refs.fileUpload.files.length == 0) {
                return;
            }

            general.App.loader.show(this);

            for (let i = 0, m = this.$refs.fileUpload.files.length; i < m; i++) {
                let file = this.$refs.fileUpload.files[i];

                if (file.size > MAX_FILE_SIZE) {
                    Files_Error.push(file);
                }
            }

            if (Files_Error.length > 0) {
                var file_name = Files_Error.map(el => el.name);
                var error_msg = `${file_name.length} file(s) exceeded file size limit. (3 Mbytes per file)`;
                general.wMsgBox.Error(error_msg);
            } else {
                var form_data = new FormData();

                for (let i = 0, m = this.$refs.fileUpload.files.length; i < m; i++) {
                    var file = this.$refs.fileUpload.files[i];

                    form_data.append("file" + i, file, file.name);
                }
                form_data.append("_id", this.selected._id);

                var url = communication.BASE_URL + "fpes/upload_evidence/";

                var res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        Authorization: auth.getToken(),
                    },
                    body: form_data,
                });

                var res_content = await res.json();

                if (res_content.Status == 1) {
                    this.selected.uploaded_evidence = res_content.Body.uploaded_evidence;
                    this.selected.modified_by = res_content.Body.modified_by;
                    this.selected.modified = res_content.Body.modified;
                    general.wMsgBox.Success(res_content.Description);
                } else {
                    general.wMsgBox.Error(res_content.Description);
                }
            }
            general.App.loader.hide(this);
        },
        check_thumb_exist() {
            var val = -1;
            var all_array = this.selected.thumbs;

            for (let i = 0, m = all_array.length; i < m; i++) {
                let el = all_array[i];
                if (el.username == this.current_username) {
                    val = i;
                }
            }

            return val;
        },
        thumb_up_onlick() {
            var found_index = this.check_thumb_exist();

            if (found_index > -1) {
                var el = this.selected.thumbs[found_index];

                if (el.value == 1) {
                    this.selected.thumbs.splice(found_index, 1);
                } else {
                    el.value = 1;
                    el.epoch = general.App.get_current_datetime_in_epoch();
                }
            } else {
                this.selected.thumbs.push({
                    username: this.current_username,
                    value: 1,
                    epoch: general.App.get_current_datetime_in_epoch()
                });
            }

            this.save_thumbs_value();
        },
        thumb_down_onlick() {
            var found_index = this.check_thumb_exist();

            if (found_index > -1) {
                var el = this.selected.thumbs[found_index];

                if (el.value == -1) {
                    this.selected.thumbs.splice(found_index, 1);
                } else {
                    el.value = -1;
                    el.epoch = general.App.get_current_datetime_in_epoch();
                }
            } else {
                this.selected.thumbs.push({
                    username: this.current_username,
                    value: -1,
                    epoch: general.App.get_current_datetime_in_epoch()
                });
            }

            this.save_thumbs_value();
        },
        async save_thumbs_value() {
            general.App.loader.show(this);
            // var new_rec = !this.selected._id;
            var url = "fpes/report_entries_evidence_crud/";

            if (this.$refs.MainForm.validate()) {
                var data = {
                    _id: this.selected._id,
                    thumbs: this.selected.thumbs
                };
                var res = await general.wBackEndComm.PostData(url, data);
                res = res.data;

                if (res.Status == 1) {
                    this.selected.modified = res.Body.modified;
                    this.selected.modified_by = res.Body.modified_by;
                    // if (new_rec) {
                    //     window.history.pushState({}, null, "/Submit-Evidence-Step2-Crud?_id=" + this.selected._id);
                    // }
                    general.wMsgBox.Success(res.Description);
                } else {
                    general.wMsgBox.Error(res.Description);
                }
            } else {
                general.wMsgBox.Error(
                    "Please fill in all required fields before click on save button."
                );
            }
            general.App.loader.hide(this);
        },
        async evidence_save_onclick() {
            general.App.loader.show(this);
            var new_rec = !this.selected._id;
            var url = "fpes/report_entries_evidence_crud/";

            if (this.$refs.MainForm.validate()) {
                var res = await general.wBackEndComm.PostData(url, this.selected);
                res = res.data;

                if (res.Status == 1) {
                    this.selected = res.Body;
                    if (new_rec) {
                        window.history.pushState({}, null, "/Submit-Evidence-Step2-Crud?uuid=33297989-4029-4a57-9aba-65724eb4cee0&_id=" + this.selected._id);
                    }
                    general.wMsgBox.Success(res.Description);
                } else {
                    general.wMsgBox.Error(res.Description);
                }
            } else {
                general.wMsgBox.Error(
                    "Please fill in all required fields before click on save button."
                );
            }
            general.App.loader.hide(this);
        },
    },
    async mounted() {
        general.App.loader.show(this);
        general.App.set_page_title("mySuite : Submit Evidence Step2 Page");
        this.$refs.fileUpload.addEventListener('change', this.checkIt);

        var query_string_id = general.App.getQueryString("_id");

        this.current_username = auth.getUsername();
        this.selected.fpes_report_entries_id = general.App.getQueryString("fpes_report_entries_id");
        this.all_status = await general.App.arango_app_selections("evidence", "status");
        this.all_group_category = await general.App.arango_app_selections("evidence", "group_category");

        if (query_string_id) {
            var url = "fpes/report_entries_evidence_crud/?_id=" + query_string_id;
            var res = await general.wBackEndComm.GetData(url);
            res = res.data;

            if (res.Status == 1) {
                this.selected = res.Body;
                general.wMsgBox.Success(res.Description);
            } else {
                general.wMsgBox.Error(res.Description);
            }
        } else {
            this.selected.status_id = this.all_status[0]._id;
            this.selected.group_category_id = this.all_group_category[0]._id;
        }
        general.App.loader.hide(this);
    },
};
</script>

<style scoped>
.test {
    height: 100vh;
    /* missing in your code */
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 100%;
}
</style>
